import React, { FC } from 'react';
import { Space } from '@10d/tend-ui-grid';

import { ArrowDown1Outline } from '../Icon';

import { TabsProps } from './types';
import { GlobalStyle, Wrapper } from './styled';
import TabBar from './TabBar';
import { TriggerType } from './TabBar/types';

const Tabs: FC<TabsProps & { dropDownTrigger?: TriggerType[] }> = props => {
  const renderTabBar: TabsProps['renderTabBar'] = tabBarProps => (
    <TabBar {...tabBarProps} size={props.size} dropDownTrigger={props.dropDownTrigger} />
  );

  return (
    <>
      <GlobalStyle />
      <Wrapper renderTabBar={renderTabBar} {...props} />
    </>
  );
};

Tabs.defaultProps = {
  moreIcon: (
    <Space size={10}>
      Еще
      <ArrowDown1Outline />
    </Space>
  ),
};

export default Tabs;
